import { useEffect } from 'react'

/** Collapses an open sidebar on mount and expands it on unmount. */
export default function useCollapsedSidebar({ sidebarActive, toggleSidebar, expandSidebar }) {
  useEffect(() => {
    if (sidebarActive) {
      toggleSidebar()
    }
    return () => expandSidebar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
